import { render, staticRenderFns } from "./fireFightingUtvCheckDetail.vue?vue&type=template&id=1bca1cbe"
import script from "./fireFightingUtvCheckDetail.vue?vue&type=script&lang=js"
export * from "./fireFightingUtvCheckDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bca1cbe')) {
      api.createRecord('1bca1cbe', component.options)
    } else {
      api.reload('1bca1cbe', component.options)
    }
    module.hot.accept("./fireFightingUtvCheckDetail.vue?vue&type=template&id=1bca1cbe", function () {
      api.rerender('1bca1cbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/fft/utv/fireFightingUtvCheckDetail.vue"
export default component.exports